<script setup lang="ts">
    import Close from '@svg/as/close.svg';
    import Search from '@svg/as/search.svg';
    import { Checkbox } from "@/vue/ui/checkbox";
    import { Input } from "@/vue/ui/input";
    import { FilterCheckboxesProps, useFilterCheckboxes } from "@/vue/composables/useFilterCheckboxes";

    const props = defineProps<FilterCheckboxesProps>();

    const { searchTerm, filteredItems } = useFilterCheckboxes(props);
</script>

<template>
    <div class="md:py-6 md:px-4 md:w-[300px]">
        <template v-if="searchable">
            <div class="mb-8 md:mb-4 relative">
                <Input
                    class="pr-20"
                    placeholder="Rechercher..."
                    type="search"
                    v-model="searchTerm"
                />
                <button class="absolute top-0 right-11 px-3 h-full text-black hover:text-primary peer-placeholder-shown:hidden" @click="searchTerm = ''">
                    <Close
                        class="w-4 h-4"
                    />
                </button>
                <div class="absolute right-11 top-1/2 -translate-y-1/2 h-8 w-[.5px] bg-neutral-400 pointer-events-none peer-placeholder-shown:hidden"></div>
                <div class="absolute grid place-content-center top-0 right-0 transition-colors duration-300 pl-3 pr-4 h-full text-neutral-900 pointer-events-none">
                    <Search
                        class="w-4 h-4"
                    />
                </div>
            </div>
        </template>
        <div class="max-h-[180px] overflow-y-auto overflow-x-hidden scrollbar scrollbar-w-[5px] scrollbar-track-rounded-full scrollbar-thumb-rounded-full scrollbar-thumb-neutral-400 scrollbar-track-neutral-100 hover:scrollbar-thumb-neutral-500">
            <div class="grid grid-cols-1 gap-y-4">
                <template v-for="item in filteredItems">
                    <label class="group/item relative flex gap-x-2 text-body-sm cursor-default">
                        <span class="absolute inset-x-0 -inset-y-1.5 group-first/item:top-0 group-last/item:bottom-0"></span>
                        <Checkbox
                            class="lg:mt-0.5"
                            :checked="item.isRefined"
                            @update:checked="state.refine(item.value)"
                        />
                        {{ item.label }}
                    </label>
                </template>
            </div>
        </div>
    </div>
</template>
